import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { createSelector } from 'reselect'

export const defaultQuizState = {
    page: 0,
    firstAttempt: true,
    answers: {},
    active: false,
    score: 0,
    completion: null,
    updated: null
    //displayFeedback: false,
    //refreshRequest: null
};


const quizAdapter = createEntityAdapter();
const selectors = quizAdapter.getSelectors();

//need our own selector so we can create the quiz if it does not exist
export const GetQuiz = id => createSelector(
    (state) => state.quizState,
    (state) => {
        var q;
        if (!(id in state.entities)) {
            q = { id: id, ...defaultQuizState };
        } else {
            q = state.entities[id];
        }
        return q;
    }
);

const quizStateSlice = createSlice({
    name: 'quizState',
    initialState: quizAdapter.getInitialState(),
    reducers: {
        UpdateQuizState: (state, action) => {
            //, updated: new Date().toISOString()
            quizAdapter.upsertOne(state, { ...action.payload });
        }
    }
});

export const { UpdateQuizState } = quizStateSlice.actions;
export default quizStateSlice.reducer;